import { Job } from 'pbs-api/job'
import path from 'webmango-utils/path'
import { toFileName } from './utils'
import { outputValue, outputGlobalConfig } from './infiledata'
import get from 'lodash/get'

export default function shFile (...args) {
  return MangoRunConfig(...args).script
}

export function MangoRunConfig (props) {
  const { runConfig, runConfigSchema, process, sample, config } = props
  const globalConfig = outputGlobalConfig(props)

  const result = outputValue({
    value: runConfig,
    schema: runConfigSchema,
    sample,
    config
  })

  const { batch } = result
  const base = toFileName(process.name)

  let { queue, project } = batch
  let server = 'raijin'

  if (queue === 'immediate' || queue === 'mangovm') {
    // immediate queue magic
    queue = 'mangovm'
    server = 'immediate'
    project = undefined
  } else {
    // use project as configured in settings if none supplied
    const defaultProject = get(config, 'config.settings.jobProject')
    if ((!project || project === 'none') && defaultProject) {
      project = defaultProject
    }
  }

  const cpus = getProcessors(globalConfig)

  // jobfs per cpu
  if (Number(batch.jobfs) > 8) {
    batch.jobfs = 8
  }
  const jobfs = ((Number(batch.jobfs) || 8) * cpus) || undefined

  return Job({
    id: props.id || base.slice(0, 15),
    path: sample.localSamplePath,
    workingPath: sample.localSampleWorkPath,
    project,
    queue,
    server,
    mem: batch.vmem,
    memUnit: batch.vmem_units,
    jobfs,
    walltime: batch['walltime (hh:mm)'],
    cpus,
    results: 'results'
  }, (job) => {
    const { id, server, output } = job
    let script = ''

    let coreDumpLimit = '0'
    if (batch.disable_core_dumps === 'false') coreDumpLimit = 'unlimited'
    const statPath = path.join(path.dirname(output), `${id}.stat`)
    job.stats = statPath

    const firstNode = process.nodes[0]
    const inputPath = firstNode && path.join(
      config.root,
      path.resolve(sample.localSamplePath, firstNode.value['inputdata/filename'])
    )

    if (batch.extra_qsub_args) script += `#PBS ${batch.extra_qsub_args}\n`
    script += [
      '',
      `PRIMARYINPUT=${inputPath}`,
      '',
      'function finish {',
      server === 'immediate'
        ? `  sstat -j $SLURM_JOB_ID.batch > ${statPath}`
        : `  qstat -xf $PBS_JOBID > ${statPath}`,
      '}',
      'trap finish EXIT',
      '',
      'uncompress-all-mpi "$PRIMARYINPUT"',
      'if [ $? -ne 0 ]; then',
      '  echo "uncompress-all-mpi failed, exiting."',
      '  exit $?',
      'fi',
      '',
      'export LANGUAGE=C',
      'export LANG=C',
      'export LC_ALL=C',
      '',
      // add pre-run commands
      ...(result.pre_run_commands ? [
        '\n#\n# BEGIN PRE RUN COMMANDS',
        result.pre_run_commands,
        '\n# END   PRE RUN COMMANDS\n#'
      ] : []),
      '',
      server === 'immediate'
        ? `MAINEXEC=${path.basename(globalConfig.executable)}` // should be on $PATH on immediate job server
        : `MAINEXEC=${globalConfig.executable}`,
      `BASE=${base}`,
      `EXTRAMPIRUNARGS=${addQuotes(result.use_mpirun_true.extra_mpirun_args)}`,
      '',
      'if [ -r `which "${MAINEXEC}_env.sh"` ]; then', // eslint-disable-line no-template-curly-in-string
      '  source `which "${MAINEXEC}_env.sh"`', // eslint-disable-line no-template-curly-in-string
      'fi',
      '',
      ...(server === 'immediate'
        ? [
          'if [ ! -z "$SLURM_JOB_CPUS_PER_NODE" ]; then',
          `  mpiexec -np $SLURM_JOB_CPUS_PER_NODE $EXTRAMPIRUNARGS bash -c "ulimit -c ${coreDumpLimit}; exec \\"$MAINEXEC\\" -base \\"$BASE\\" "`,
          'else',
          '  echo "This script: $0, cannot be run directly. Please run via the PBS queue manager: qsub"',
          '  exit 1',
          'fi'
        ] : [
          'if [ ! -z "$PBS_NCPUS" ]; then',
          '  unset module', // NCI workaround. Environment variables with multi-line values are not correctly duplicated to secondary nodes.
          `  mpiexec -np $PBS_NCPUS $EXTRAMPIRUNARGS bash -c "ulimit -c ${coreDumpLimit}; exec \\"$MAINEXEC\\" -base \\"$BASE\\" "`,
          'else',
          '  echo "This script: $0, cannot be run directly. Please run via the PBS queue manager: qsub"',
          '  exit 1',
          'fi'
        ]
      ),
      ''
    ].join('\n')
    return script
  })
}

function getProcessors ({ MPI }) {
  return MPI.num_processors_x * MPI.num_processors_y * MPI.num_processors_z
}

function addQuotes (str) {
  if (!str) return ''
  return JSON.stringify(str)
}



// WEBPACK FOOTER //
// ../webmango-core/shfile.js